import { keepPreviousData } from "@tanstack/react-query";

import { STALE_TIME } from "#app/http/ReactQueryProvider";
import { fetchQuoteRequestsV2 } from "#modules/quoteRequestsV2/infra/fetchQuoteRequests.v2.api";
import { queryKeys } from "#shared/queryKeys/queryKeys";

export const quoteRequestsV2Query = ({ page, perPage }: { page: number; perPage: number }) => {
  const queryKey = queryKeys.quoteRequests.v2.search(page, perPage);

  return {
    queryKey,
    queryFn: () => fetchQuoteRequestsV2({ page, perPage }),
    placeholderData: keepPreviousData,
    staleTime: STALE_TIME,
  };
};
